import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { MatchCustomNameUpdateResponse } from "@app/core/shared/domain/api-types-filtered";

@Injectable({
  providedIn: "root",
})
export class editMatchNameWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    match_code: string,
    custom_name: string,
    token: string
  ): Observable<MatchCustomNameUpdateResponse> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.put)
      .setUrl(ApiUrls.EDIT_MATCH_NAME_ENDPOINT(match_code))
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        custom_name,
      })
      .build();
    return this.baseHandler.execute(parameters);
  }
}
